import {DocumentDataModel} from '../../../models/document/document-data.model';
import {CaseTooth} from './CaseTooth';
import {
  AnnotationDefaults, DrawCanvasDefaults, DrawFunctionDefaults,
  DrawingToolsDefaults, DrawMagnificationDefaults,
  DrawStampDefaults,
  DrawTextDefaults
} from '../../../models/configuration/draw/annotation-defaults.model';

export class TDOxImage {
  ImageID: string;
  DocumentId: string;
  ParentDocumentId: string;
  ImageName: string;
  bImageLoaded: boolean;
  Categories: string[];
  bImageSaved: boolean;
  URL: string;
  contrastVal: number = 0;
  brightnessVal: number = 0;
  gammaVal: number = 100;
  sharpnessVal: string = '0';
  selectedFile: File;
  blob: string;
  annotationXmlData: string;
  PatientID: string;
  selected: boolean;
  isMaximizing: boolean = false;
  selectedTeeth: CaseTooth[];
  AutoSave: boolean = true;
  loadedDocument: DocumentDataModel;
  folderId: string;
  thumbDocId: string;
  imageSource: string;
  desktopAcquireDocId: string;
  deviceId: string;
  isRevert: boolean = false;
  createDate: Date;
  drawTextDefaults: DrawTextDefaults;
  drawStampDefaults: DrawStampDefaults;
  drawToolsDefaults: DrawingToolsDefaults;
  annotationsDefaults: AnnotationDefaults;
  drawFunctionToolsDefaults: DrawFunctionDefaults;
  drawMagnificationDefaults: DrawMagnificationDefaults;
  drawViewDetailDefaults: DrawMagnificationDefaults;
  drawCanvasDefaults: DrawCanvasDefaults;
}
